export const TAG_SHEET_LINE_ITEM_STEP_TITLE = 'Line Items';
export const TAG_SHEET_NO_SELECTED_DATA_TITLE =
  'Something went wrong. Please select the proper campaigns for ad assignment.';
export const UNMAPPED_GROUP_ID = '__unmapped__';
